<template>
  <b-modal id="modal-shiporder" size="xl">
    <!--Content-->
    <template slot="modal-header">
      <div class>
        <!--Header-->
        <div></div>
      </div>
    </template>

    <div class="animated fadeIn">
      <b-row>
        <b-col lg="12">
          <!-- <b-card>
        <div slot="header">User Profile</div>-->
          <b-form>
            <b-row>
              <b-col md="6">
                <b-form-group>
                  <b-input-group>
                    <b-input-group-prepend>
                      <b-input-group-text class="standardizedWidth"
                        >Order ID</b-input-group-text
                      >
                    </b-input-group-prepend>
                    <b-form-input
                      v-model="shipping.shipping_order_edit.PONumber"
                      autocomplete="off"
                      type="text"
                      id="OrderID"
                    ></b-form-input>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group>
                  <b-input-group>
                    <b-input-group-prepend>
                      <b-input-group-text class="standardizedWidth"
                        >Ticket ID</b-input-group-text
                      >
                    </b-input-group-prepend>
                    <b-form-input
                      v-model="shipping.shipping_order_edit.ShippingOrderID"
                      autocomplete="off"
                      type="text"
                      id="CustomerID"
                    ></b-form-input>
                  </b-input-group>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col md="6">
                <b-form-group>
                  <b-input-group>
                    <b-input-group-prepend>
                      <b-input-group-text class="standardizedWidth"
                        >Customer ID</b-input-group-text
                      >
                    </b-input-group-prepend>
                    <b-form-input
                      v-model="shipping.shipping_order_edit.BuffiniCustomerID"
                      autocomplete="off"
                      type="text"
                      id="WebCustomerID"
                    ></b-form-input>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group>
                  <b-input-group>
                    <b-input-group-prepend>
                      <b-input-group-text class="standardizedWidth"
                        >Received</b-input-group-text
                      >
                    </b-input-group-prepend>
                    <b-form-input
                      v-model="shipping.shipping_order_edit.DateOrdered"
                      autocomplete="off"
                      type="text"
                      id="Quantity"
                    ></b-form-input>
                  </b-input-group>
                </b-form-group>
              </b-col>
            </b-row>
            <!-- <b-row>
            <b-col md="6">
              <b-form-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <b-input-group-text class="standardizedWidth">CAP/IOV</b-input-group-text>
                  </b-input-group-prepend>
                  <b-form-input
                    v-model="shipping.shipping_order_edit.CAP"
                    autocomplete="off"
                    type="text"
                    id="CAP"
                  ></b-form-input>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group>
                <b-input-group>
                  <a
                    :href="artworkLink"
                    style="width:250px;"
                    target="_blank"
                    class="btn btn-success"
                    role="button"
                  >
                    Download Hi-Res PDF
                    <i class="fa fa-download appendIcon"></i>
                  </a>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="12">&nbsp;</b-col>
          </b-row>-->

            <b-row>
              <b-col md="6">
                <b-form-group>
                  <b-input-group>
                    <b-input-group-prepend>
                      <b-input-group-text class="standardizedWidth"
                        >Delivered To</b-input-group-text
                      >
                    </b-input-group-prepend>
                    <b-form-input
                      v-model="shipping.shipping_order_edit.ShipName1"
                      autocomplete="off"
                      type="text"
                      id="ship_name"
                    ></b-form-input>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group>
                  <b-input-group>
                    <b-input-group-prepend>
                      <b-input-group-text class="standardizedWidth"
                        >Company</b-input-group-text
                      >
                    </b-input-group-prepend>
                    <b-form-input
                      v-model="shipping.shipping_order_edit.ShipName2"
                      autocomplete="off"
                      type="text"
                      id="ship_name"
                    ></b-form-input>
                  </b-input-group>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="6">
                <b-form-group>
                  <b-input-group>
                    <b-input-group-prepend>
                      <b-input-group-text class="standardizedWidth"
                        >Address</b-input-group-text
                      >
                    </b-input-group-prepend>
                    <b-form-input
                      v-model="shipping.shipping_order_edit.ShipAddress1"
                      autocomplete="off"
                      type="text"
                      id="ship_address_1"
                    ></b-form-input>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group>
                  <b-input-group>
                    <b-input-group-prepend>
                      <b-input-group-text class="standardizedWidth"
                        >Ste./Bldg</b-input-group-text
                      >
                    </b-input-group-prepend>
                    <b-form-input
                      v-model="shipping.shipping_order_edit.ShipAddress2"
                      autocomplete="off"
                      type="text"
                      id="ship_address_2"
                    ></b-form-input>
                  </b-input-group>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="6">
                <b-form-group>
                  <b-input-group>
                    <b-input-group-prepend>
                      <b-input-group-text class="standardizedWidth"
                        >City</b-input-group-text
                      >
                    </b-input-group-prepend>
                    <b-form-input
                      v-model="shipping.shipping_order_edit.ShipCity"
                      autocomplete="off"
                      type="text"
                      id="ship_city"
                    ></b-form-input>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group>
                  <b-input-group>
                    <b-input-group-prepend>
                      <b-input-group-text class="standardizedWidth"
                        >State/Province</b-input-group-text
                      >
                    </b-input-group-prepend>
                    <b-form-input
                      v-model="shipping.shipping_order_edit.ShipState"
                      autocomplete="off"
                      type="text"
                      id="ship_state"
                    ></b-form-input>
                  </b-input-group>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="6">
                <b-form-group>
                  <b-input-group>
                    <b-input-group-prepend>
                      <b-input-group-text class="standardizedWidth"
                        >Postal Code</b-input-group-text
                      >
                    </b-input-group-prepend>
                    <b-form-input
                      v-model="shipping.shipping_order_edit.ShipPostalCode"
                      autocomplete="off"
                      type="text"
                      id="ship_postal_code"
                    ></b-form-input>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group>
                  <b-input-group>
                    <b-input-group-prepend>
                      <b-input-group-text class="standardizedWidth"
                        >Country</b-input-group-text
                      >
                    </b-input-group-prepend>
                    <b-form-input
                      v-model="shipping.shipping_order_edit.ShipCountry"
                      autocomplete="off"
                      type="text"
                      id="ship_country"
                    ></b-form-input>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <!-- <b-col md="6">
              <b-form-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <b-input-group-text class="standardizedWidth">Shipping Method</b-input-group-text>
                  </b-input-group-prepend>
                  <b-form-input
                    v-model="shipping.shipping_order_edit.ship_method"
                    autocomplete="off"
                    type="text"
                    id="ship_method"
                  ></b-form-input>
                </b-input-group>
              </b-form-group>
            </b-col>-->
            </b-row>
            <b-row>
              <b-col md="6">
                <b-form-group>
                  <b-input-group>
                    <b-button
                      style="width:200px;"
                      size="md"
                      variant="primary"
                      @click="$bvModal.hide('modal-shiporder')"
                    >
                      <i class="fa fa-arrow-left"></i>
                      Close Order Detail
                    </b-button>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col md="6" v-if="isICap || isMCap">
                <b-form-group>
                  <b-input-group>
                    <!-- <b-button variant="success" @click="LoadArtwork">Download Hi-Res PDF</b-button> -->
                    <a
                      :href="artworkLink"
                      target="_blank"
                      class="btn btn-success"
                      style="width:200px;"
                      role="button"
                    >
                      Download IOV Artwork
                      <!-- <i class="fa fa-search appendIcon"></i> -->
                    </a>
                    <a
                      v-if="hasCoverLetter"
                      :href="mcapArtworkLink"
                      target="_blank"
                      class="btn btn-success ml-3"
                      style="width:200px;"
                      role="button"
                    >
                      Download Cover Letter
                      <!-- <i class="fa fa-search appendIcon"></i> -->
                    </a>
                  </b-input-group>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="12">&nbsp;</b-col>
            </b-row>
            <b-row>
              <b-col md="12">
                <b-tabs>
                  <b-tab active>
                    <template slot="title">
                      <i class="fa fa-cog"></i>
                      <span class="ml-1">Kit Information</span>
                    </template>
                    <br />
                    <b-list-group>
                      <b-list-group-item>
                        <b-row>
                          <b-col sm="6">
                            <b-form-group>
                              <b-input-group>
                                <b-input-group-prepend>
                                  <b-input-group-text class="standardizedWidth"
                                    >Kit Type</b-input-group-text
                                  >
                                </b-input-group-prepend>
                                <b-form-input
                                  v-model="shipping.shipping_order_edit.KitType"
                                  autocomplete="off"
                                  type="text"
                                  id="ship_country"
                                ></b-form-input>
                              </b-input-group>
                            </b-form-group>
                          </b-col>
                          <b-col sm="6">
                            <b-form-group>
                              <b-input-group>
                                <b-input-group-prepend>
                                  <b-input-group-text class="standardizedWidth"
                                    >Culture</b-input-group-text
                                  >
                                </b-input-group-prepend>
                                <b-form-input
                                  v-model="shipping.shipping_order_edit.Culture"
                                  autocomplete="off"
                                  type="text"
                                  id="ship_country"
                                ></b-form-input>
                              </b-input-group>
                            </b-form-group>
                          </b-col>
                        </b-row>
                        <b-row>
                          <b-col md="6">
                            <b-form-group>
                              <b-input-group>
                                <b-input-group-prepend>
                                  <b-input-group-text class="standardizedWidth"
                                    >Fulfillment Type</b-input-group-text
                                  >
                                </b-input-group-prepend>
                                <b-form-input
                                  v-model="
                                    shipping.shipping_order_edit.FulfillmentType
                                  "
                                  autocomplete="off"
                                  type="text"
                                  id="ship_country"
                                ></b-form-input>
                              </b-input-group>
                            </b-form-group>
                          </b-col>
                          <b-col md="6">
                            <b-form-group>
                              <b-input-group>
                                <b-input-group-prepend>
                                  <b-input-group-text class="standardizedWidth"
                                    >Extra Full Kits</b-input-group-text
                                  >
                                </b-input-group-prepend>
                                <b-form-input
                                  v-model="
                                    shipping.shipping_order_edit.ExtraFullKits
                                  "
                                  autocomplete="off"
                                  type="text"
                                  id="ship_country"
                                ></b-form-input>
                              </b-input-group>
                            </b-form-group>
                          </b-col>
                        </b-row>
                        <b-row>
                          <b-col md="6">
                            <b-form-group>
                              <b-input-group>
                                <b-input-group-prepend>
                                  <b-input-group-text class="standardizedWidth"
                                    >Extra Caps</b-input-group-text
                                  >
                                </b-input-group-prepend>
                                <b-form-input
                                  v-model="
                                    shipping.shipping_order_edit.ExtraCAPs
                                  "
                                  autocomplete="off"
                                  type="text"
                                  id="ship_country"
                                ></b-form-input>
                              </b-input-group>
                            </b-form-group>
                          </b-col>
                          <b-col md="6">
                            <b-form-group>
                              <b-input-group>
                                <b-input-group-prepend>
                                  <b-input-group-text class="standardizedWidth"
                                    >Extra Notecards</b-input-group-text
                                  >
                                </b-input-group-prepend>
                                <b-form-input
                                  v-model="
                                    shipping.shipping_order_edit.ExtraNoteCards
                                  "
                                  autocomplete="off"
                                  type="text"
                                  id="ship_country"
                                ></b-form-input>
                              </b-input-group>
                            </b-form-group>
                          </b-col>
                        </b-row>
                        <b-row>
                          <b-col md="6">
                            <b-form-group>
                              <b-input-group>
                                <b-input-group-prepend>
                                  <b-input-group-text class="standardizedWidth"
                                    >Extra Stickers</b-input-group-text
                                  >
                                </b-input-group-prepend>
                                <b-form-input
                                  v-model="
                                    shipping.shipping_order_edit.ExtraStickers
                                  "
                                  autocomplete="off"
                                  type="text"
                                  id="ship_country"
                                ></b-form-input>
                              </b-input-group>
                            </b-form-group>
                          </b-col>
                          <b-col md="6">
                            <b-form-group>
                              <b-input-group v-if="hasTrackingInfo">
                                <!-- <b-button variant="success" @click="LoadArtwork">Download Hi-Res PDF</b-button> -->
                                <a
                                  :href="trackingLink"
                                  target="_blank"
                                  class="btn btn-orange"
                                  style="width:250px;"
                                  role="button"
                                >
                                  Track this package
                                  <i class="fa fa-search appendIcon"></i>
                                </a>
                              </b-input-group>
                            </b-form-group>
                          </b-col>
                        </b-row>
                      </b-list-group-item>
                    </b-list-group>
                  </b-tab>
                  <b-tab>
                    <template slot="title">
                      <i class="fa fa-cog"></i>
                      <span class="ml-1">Production Activtiy</span>
                    </template>
                    <br />
                    <b-list-group>
                      <b-list-group-item>
                        <b-row>
                          <b-col md="2">
                            <b>Status Event</b>
                          </b-col>
                          <b-col md="2">
                            <b>Time Stamp</b>
                          </b-col>
                          <b-col md="1">
                            <b>Carrier</b>
                          </b-col>
                          <b-col md="1">
                            <b>Method</b>
                          </b-col>
                          <b-col md="1">
                            <b>Cartons</b>
                          </b-col>
                          <b-col md="1">
                            <b>Weight</b>
                          </b-col>
                          <b-col md="4">
                            <b>Tracking Number</b>
                          </b-col>
                        </b-row>
                      </b-list-group-item>
                      <ShipStatusRow
                        v-for="activity in shipping.shipping_order_edit
                          .Activity"
                        :key="activity.ShippingStatusID"
                        :activity="activity"
                      />
                    </b-list-group>
                  </b-tab>
                </b-tabs>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="12">&nbsp;</b-col>
            </b-row>
          </b-form>
          <!-- </b-card> -->
        </b-col>
      </b-row>
    </div>
    <template slot="modal-footer">
      <div
        slot
        class="modal-footer justify-content-center"
        style="border:none;"
      >
        <b-button
          class="mr-2"
          type="submit"
          size="md"
          variant="primary"
          data-dismiss="modal"
          @click="$bvModal.hide('modal-shiporder')"
          aria-label="Close"
          >Close</b-button
        >
      </div>
    </template>
  </b-modal>
</template>

<script>
import { mapState } from "vuex";
import ShipStatusRow from "@/components/CustomRowComponents/ShipStatusRow.vue";
export default {
  name: "OneTimeOrder",
  data() {
    return {
      hasCoverLetter: false,
      selected: [] // Must be an array reference!
    };
  },
  methods: {
    back() {
      this.$router.go(-1);
    },
    loadArtwork() {}
  },
  computed: {
    ...mapState(["shipping", "n_user"]),
    artworkLink() {
      return (
        "https://proofs.icap-maker.com/GetHistoricalpdf.aspx?OrderID=" +
        this.$store.state.shipping.shipping_order_edit.PONumber
      );
    },
    mcapArtworkLink() {
      return (
        "https://dashboard.icap-maker.com/CoverLetters/" +
        this.$store.state.shipping.shipping_order_edit.BuffiniCustomerID +
        "-Letter.pdf"
      );
    },
    hasTrackingInfo() {
      return this.$store.state.shipping.shipping_order_edit.TrackingNumber;
    },
    trackingLink() {
      return (
        "https://www.fedex.com/apps/fedextrack/index.html?tracknumbers=" +
        this.$store.state.shipping.shipping_order_edit.TrackingNumber
      );
    },
    isICap() {
      return (
        this.$store.state.shipping.shipping_order_edit.FulfillmentType === "I"
      );
    },
    isMCap() {
      return (
        this.$store.state.shipping.shipping_order_edit.FulfillmentType === "M"
      );
    }
  },
  components: {
    ShipStatusRow
  }
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.input-group-text {
  color: #111;
}
</style>
